export default class currentUser {
    userEmail
    userId
    userName

    constructor( object ) {
        this.userEmail = object.userEmail
        this.userId = object.userId
        this.userName = object.userName
    }
}